import { Dashboard, Category } from '../../models';
import { DashboardThumbnailWidget } from '../../widgets/dashboardThumbnail/dashboardThumbnail.widget';
import { IDispatcherService, IDispatcher } from '../';
import { IDashboardActionsService } from './dashboards.actionCreator';

export interface IDashboardStoreService {
    getOne: (guid: string) => angular.IPromise<Dashboard>;
    getAll: (force?: boolean) => angular.IPromise<Dashboard[]>;
    addOne: (targetDashboard: Dashboard, filter?: boolean) => angular.IPromise<Dashboard[]>;
    addManyForApplication: (targetDashboards: Dashboard[], appName: string, filter?: boolean) => angular.IPromise<Dashboard[]>;
    updateOne: (targetDashboard: Dashboard, filter?: boolean) => angular.IPromise<Dashboard[]>;
    updateMany: (targetDashboards: Dashboard[], filter?: boolean) => angular.IPromise<Dashboard[]>;
    deleteOne: (guid: string) => angular.IPromise<Dashboard[]>;
    // Direct call to service
    getDashboardThumbnails: (dashboards: Dashboard[]) => DashboardThumbnailWidget[];
    getOrphanCategories: (dashboards: Dashboard[], categories: Category[]) => string[];
}

export interface IDashboardActionDispatcherService extends IDispatcherService<IDashboardStoreService> { }

export class DashboardActionDispatcherService implements IDashboardActionDispatcherService {
    static serviceId = 'dashboardActionDispatcherService';

    static $inject = ['dashboardActionsService'];

    constructor(private _actionService: IDashboardActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IDashboardStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(actionService.getOne(guid)),
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                addOne: (target: Dashboard, filter?: boolean) => dispatch(actionService.addOne(target, filter)),
                addManyForApplication: (target: Dashboard[], appName: string, filter?: boolean) => dispatch(actionService.addManyForApplication(target, appName, filter)),
                updateOne: (target: Dashboard, filter?: boolean) => dispatch(actionService.updateOne(target, filter)),
                updateMany: (targets: Dashboard[], filter?: boolean) => dispatch(actionService.updateMany(targets, filter)),
                deleteOne: (guid: string) => dispatch(actionService.deleteOne(guid)),
                getDashboardThumbnails: (dashboards: Dashboard[]) => actionService.getDashboardThumbnails(dashboards),
                getOrphanCategories: (dashboards: Dashboard[], categories: Category[]) => actionService.getOrphanCategories(dashboards, categories)
            }
        };
    }
}